// src/web/storage.ts
var REMEMBER_ME_KEY = "syncbox_remember_me";
var TOKENS_KEY = "syncbox_auth_tokens";
function selectedStorage() {
  return localStorage.getItem(REMEMBER_ME_KEY) === "true" ? localStorage : sessionStorage;
}
var webStorageAdapter = {
  getItem: async (key) => {
    try {
      if (key === REMEMBER_ME_KEY) return localStorage.getItem(key);
      const selected = selectedStorage().getItem(key);
      if (selected !== null) return selected;
      const legacy = localStorage.getItem(key);
      if (key === TOKENS_KEY && legacy !== null) {
        localStorage.setItem(REMEMBER_ME_KEY, "true");
      }
      return legacy;
    } catch (error) {
      console.error("Error getting item from localStorage:", error);
      return null;
    }
  },
  setItem: async (key, value) => {
    try {
      if (key === REMEMBER_ME_KEY) {
        localStorage.setItem(key, value);
      } else {
        selectedStorage().setItem(key, value);
      }
    } catch (error) {
      console.error("Error setting item to localStorage:", error);
    }
  },
  removeItem: async (key) => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (error) {
      console.error("Error removing item from localStorage:", error);
    }
  },
  setPersistence: async (persistent) => {
    const tokenValue = sessionStorage.getItem(TOKENS_KEY) ?? localStorage.getItem(TOKENS_KEY);
    localStorage.removeItem(TOKENS_KEY);
    sessionStorage.removeItem(TOKENS_KEY);
    if (persistent) {
      localStorage.setItem(REMEMBER_ME_KEY, "true");
      if (tokenValue !== null) localStorage.setItem(TOKENS_KEY, tokenValue);
    } else {
      localStorage.removeItem(REMEMBER_ME_KEY);
      if (tokenValue !== null) sessionStorage.setItem(TOKENS_KEY, tokenValue);
    }
  }
};
var storage_default = webStorageAdapter;

export {
  webStorageAdapter,
  storage_default
};
